import { SellerId, SellerSlug } from 'framework/sellers'
import { EcommerceService } from 'services'
import type { SellersListQueryParams } from '.'

class SellerService extends EcommerceService {
  list(params: SellersListQueryParams) {
    const { page } = params
    const self = this
    const url = `/farmers?page=${page || 1}`
    const req = self.setUrl(url).get()
    return req
  }

  getById(sellerId: SellerId) {
    const self = this
    const url = `/farmers/${sellerId}`
    const req = self.setUrl(url).get()
    return req
  }

  getBySlug(sellerSlug: SellerSlug) {
    const self = this
    const url = `/farmers/${sellerSlug}`
    const req = self.setUrl(url).get()
    return req
  }

  getFeaturedSeller() {
    const self = this
    const url = '/farmers/featured/produtor_em_destaque'
    const req = self.setUrl(url).get()
    return req
  }
}

export default SellerService
